import { JIRA_AUTH_STATE, PM_AUTH_STATES } from 'common/constants/constants';
import { getConnectivityStatus } from 'common/services/jira-auth.service';

export const step1ErrorMeesages = {
  connectivity: 'Failed to connect to the specified URL',
  not_jira: 'Failed to get the Jira server version',
  unsupported_version: 'Your Jira server version is not supported'
};

export const checkConnectivityStatus = async url => {
  try {
    const result = await getConnectivityStatus(url);
    return result.toLowerCase() !== 'failed_to_connect';
  } catch (e) {
    return false;
  }
};

export const isSensorFinishSetup = ({ state } = {}) => {
  return PM_AUTH_STATES.IN_PROGRESS !== state;
};

export const isWaitingForUserInputs = jiraState => {
  return [
    JIRA_AUTH_STATE.EXPECTING_APP_AUTHORIZATION,
    JIRA_AUTH_STATE.EXPECTING_APP_LINK,
    JIRA_AUTH_STATE.FAILING
  ].includes(jiraState);
};

export const getVersionErrorMessage = version => {
  const versionRegex = /^(\d+\.)?(\d+\.)?(\*|\d+)$/;

  if (!version) {
    return step1ErrorMeesages.not_jira;
  }
  if (version.toLowerCase() === 'cloud') {
    return null;
  }
  if (!versionRegex.test(version)) {
    return step1ErrorMeesages.not_jira;
  }

  return version >= '7.0.0' ? null : step1ErrorMeesages.unsupported_version;
};

export const openAuthPage = authUrl => {
  window.open(authUrl);
};
